module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features address-info sr-info download-info"
  }, [_c('div', {
    staticClass: "address-container"
  }, [_c('div', {
    staticClass: "columns aic"
  }, [_c('div', {
    staticClass: "column is-flex aic jcc"
  }, [_c('div', {
    staticClass: "feature"
  }, [_c('p', [_c('img', {
    staticClass: "img-miner",
    attrs: {
      "src": '/img/ios-app/app-' + _vm.mode + '.png'
    }
  })]), _c('div', {
    staticClass: "feature-helvetica"
  }), _c('p')])]), _c('div', {
    staticClass: "column aic is-flex fdc"
  }, [_vm._m(0), _c('div', {
    staticClass: "feature mb-5 fw-400 mt-20"
  }, [_c('div', {
    staticClass: "referral-template-home has-text-left"
  }, [_c('p', {
    staticClass: "fs-15 fw-700"
  }, [_vm._v("Version " + _vm._s(_vm.current.versionNumber) + " ")]), _c('p', {
    staticClass: "fs-10 mb-10"
  }, [_vm._v(_vm._s(_vm.current.buildDate))]), _vm._m(1)])]), _vm._m(2)])]), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature mt-10 title-desc"
  }, [_c('span', {
    staticClass: "title text-white-on-dark"
  }, [_vm._v("Keep ")]), _c('span', {
    staticClass: "title pink"
  }, [_vm._v("track ")]), _c('span', {
    staticClass: "title text-white-on-dark"
  }, [_vm._v("of your ")]), _c('span', {
    staticClass: "title pink"
  }, [_vm._v("earnings")]), _c('span', {
    staticClass: "title text-white-on-dark"
  }, [_vm._v(", monitor multiple addresses at the same time and more.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mb-10"
  }, [_c('li', {
    staticClass: "new-feature-li"
  }, [_c('b', [_vm._v("Our Android App is now available!")])]), _c('li', {
    staticClass: "new-feature-li"
  }, [_vm._v("Review your balance across all your addresses.")]), _c('li', {
    staticClass: "new-feature-li"
  }, [_vm._v("Check your active algorithms in one place.")]), _c('li', {
    staticClass: "new-feature-li"
  }, [_vm._v("Manage your payments.")]), _c('li', {
    staticClass: "new-feature-li"
  }, [_vm._v("Stay up to date with the latest news.")]), _c('li', {
    staticClass: "new-feature-li"
  }, [_vm._v("Support for Light and Dark theme.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex aic mt-10"
  }, [_c('a', {
    staticClass: "get-app-image android",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.unmineable.mobileapp",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/app-store-badge-android.png"
    }
  })]), _c('a', {
    staticClass: "get-app-image",
    attrs: {
      "href": "https://apps.apple.com/pe/app/unmineable/id6444838563",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/app-store-badge.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature feature-helvetica has-text-left"
  }, [_c('hr'), _c('p', {
    staticClass: "smaller-content"
  }, [_vm._v("(*) "), _c('b', {
    staticClass: "w400"
  }, [_vm._v("Note that our monitoring app is not capable of crypto mining, you must be mining with a computer or ASIC device to monitor your progress.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baa53eb8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Monitoring_App.vue
// module id = 391
// module chunks = 1